module.exports = __webpack_public_path__ + "static/media/sh-ta.fc7782b1.svg";